import clsx from 'clsx';
import { memo } from 'react';

import { Layout } from '../Layout/Layout';
import { ToolbarItemButton } from './subcomponents/ToolbarItemButton';
import { Toolbar as ToolbarProps } from './types';
import './Toolbar.css';

export const Toolbar = memo(
  ({
    activeItemKey,
    items,
    variant = 'default',
    disabled = false,
    onSelectItem,
  }: ToolbarProps) => {
    const isDisabled = disabled !== false;
    // When disabled, every control shares the same reason as its tooltip so the
    // "why" is discoverable; otherwise each item keeps its own tooltip.
    const disabledReason =
      disabled === false ? undefined : disabled.disabledReason;

    return (
      <Layout
        className={clsx('eds-toolbar', {
          'eds-toolbar--embedded': variant === 'embedded',
        })}
        direction="column"
        spacing="s"
      >
        {items.map((item) => (
          <ToolbarItemButton
            key={item.itemKey}
            disabled={isDisabled}
            isActive={activeItemKey === item.itemKey}
            item={item}
            tooltipText={disabledReason ?? item.tooltip}
            onSelectItem={onSelectItem}
          />
        ))}
      </Layout>
    );
  },
);

Toolbar.displayName = 'Toolbar';
